<template>
    <div>
        <b-input-group>
            <b-form-select
                class="apprentice-primary-select"
                v-on:change="updateRoadmap()"
                v-model="selected"
                :options="roadmaps"
                value-field="id"
                text-field="title">
                <template slot="first">
                    <option
                        v-if="!selected"
                        :value="null">
                        {{ $t('group.choose_a_roadmap') }}
                    </option>
                </template>
            </b-form-select>
            <b-input-group-append>
                <b-button
                    class="btn-management btn-roadmap-management"
                    variant="primary"
                    @click="showModal()">
                    <span>{{ $t('common.manage') }}</span></b-button
                >
            </b-input-group-append>
        </b-input-group>

        <b-modal
            v-model="show_modal"
            :title="$t('group.manage_roadmap')"
            size="lg"
            modal-class="apprentice-default-modal roadmap-modal"
            :ok-title="$t('common.close')"
            ok-only>
            <design-2021-apprentice-data-table
                class="roadmap-options-table"
                v-if="roadmaps.length"
                :fields="fields"
                :items="roadmaps">
                <template #options>
                    <b-button
                        class="btn-add btn-add-roadmap-step"
                        variant="primary"
                        @click="newRoadmap()">
                        {{ $t('group.new_roadmap') }}
                    </b-button>
                </template>

                <template #cell(actions)="row">
                    <div class="actions">
                        <b-button
                            class="btn-hand-pointer btn-select-roadmap"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :title="$t('common.choose')"
                            @click="selectRoadmap(row.item.id)">
                        </b-button>
                        <b-button
                            class="btn-edit btn-edit-roadmap"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :href="'/roadmap/edit/' + row.item.id + '/' + groupIn.id"
                            :title="$t('common.edit')">
                        </b-button>
                        <b-button
                            class="btn-duplicate btn-duplicate-roadmap"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :title="$t('common.copy')"
                            @click="onDuplicate(row.item.id)">
                        </b-button>
                        <b-button
                            class="btn-remove btn-remove-roadmap"
                            v-b-tooltip.hover
                            variant="danger-icon-only"
                            :title="$t('common.delete')"
                            @click="onRemove(row.item.id)">
                        </b-button>
                    </div>
                </template>
            </design-2021-apprentice-data-table>

            <div
                class="not-found with-header empty-roadmap-steps-list"
                v-else>
                <div
                    class="btn-add-circle icon"
                    @click="newRoadmap()"></div>
                <div class="alert-notice">{{ $t('group.no_roadmap_found') }}</div>
            </div>
        </b-modal>

        <b-modal
            v-model="new_roadmap_modal"
            :title="$t('group.new_roadmap')"
            @ok="startNewRoadmap"
            :cancel-title="$t('common.cancel')"
            cancel-variant="outline-primary"
            :ok-title="$t('common.save')"
            modal-class="apprentice-default-modal">
            <div class="roadmap-name">
                <div
                    class="errors"
                    v-if="error">
                    <b-alert
                        variant="danger"
                        show
                        >{{ $t('group.questionnaire_title_cannot_be_empty') }}
                    </b-alert>
                </div>
                <b-form-group
                    class="roadmap-name-group"
                    :label="$t('group.name_roadmap')"
                    label-for="roadmap-input-label">
                    <b-form-input
                        id="roadmap-input-label"
                        v-model="title"
                        :placeholder="$t('group.type_here_the_title_of_the_roadmap')"></b-form-input>
                </b-form-group>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-select-roadmap-component',
    props: ['roadmapsIn', 'groupIn'],
    data() {
        return {
            selected: this.groupIn.roadmap_id,
            title: null,
            show_modal: false,
            new_roadmap_modal: false,
            roadmaps: this.roadmapsIn,
            fields: [
                {
                    key: 'title',
                    label: this.$t('common.title'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            error: false,
        };
    },
    methods: {
        showModal() {
            this.show_modal = true;
        },
        newRoadmap() {
            this.new_roadmap_modal = true;
        },
        onDuplicate(id) {
            this.alert
                .confirm(
                    this.$t('group.copy_roadmap_confirmation_title'),
                    this.$t('group.copy_roadmap_confirmation_body'),
                    this.$t('common.yes_copy'),
                )
                .then((confirm) => {
                    if (confirm) {
                        location.href = this.routes.baseUrl() + '/roadmap/copy/' + id + '/' + this.groupIn.id;
                    }
                });
        },
        onRemove(id) {
            this.alert
                .confirm(
                    this.$t('group.delete_roadmap_confirmation_title'),
                    this.$t('group.delete_roadmap_confirmation_body'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.baseUrl() + '/roadmap/delete/' + id).then(
                            (response) => {
                                for (let roadmap of this.roadmaps) {
                                    if (roadmap.id == id) {
                                        this.roadmaps.splice(this.roadmaps.indexOf(roadmap), 1);

                                        if (this.selected == id) {
                                            this.selected = null;
                                            this.updateRoadmap();
                                        }
                                    }
                                }
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        updateRoadmap() {
            this.alert.saving();

            const data = {
                id: this.selected,
            };

            this.axios.post(this.routes.baseUrl() + '/roadmap/set/' + this.groupIn.id, data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        selectRoadmap(id) {
            this.selected = id;
            this.updateRoadmap();
            this.show_modal = false;
        },
        startNewRoadmap(bvModalEvt) {
            this.error = false;
            if (this.title === '' || this.title === null) {
                bvModalEvt.preventDefault();
                this.error = true;
                return;
            }

            this.alert.saving();

            const data = {
                title: this.title,
            };

            this.axios.post(this.routes.baseUrl() + '/roadmap/create/' + this.groupIn.id, data).then(
                (response) => {
                    const url =
                        this.routes.baseUrl() + '/roadmap/edit/' + response.data.roadmap_id + '/' + this.groupIn.id;
                    window.location.href = url;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.roadmap-options {
    .input-group {
        border: 0;
        border-radius: $border-radius-content;
        flex-direction: column;
    }

    .btn-roadmap-management,
    .apprentice-primary-select {
        width: calc(100% - 12px);
    }

    .apprentice-primary-select {
        margin-bottom: map-get($grid-gutter-spacing, 'five');
        padding-top: map-get($grid-gutter-spacing, 'ten');
        padding-bottom: map-get($grid-gutter-spacing, 'ten');
        border: 1px solid $border-color;
        border-top-right-radius: $border-radius-content !important;
        border-bottom-right-radius: $border-radius-content !important;
    }

    .btn-roadmap-management {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        font-size: $base-font-size;

        &:before,
        span {
            align-self: center;
        }

        &:before {
            font-size: $base-font-size;
        }
    }
}

.actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .btn {
        font-size: 1.125rem;

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
            margin-bottom: map-get($grid-gutter-spacing, 'ten');
        }
    }

    .btn-edit-roadmap:before {
        margin-right: 0;
    }
}

::v-deep .roadmap-options-table {
    .apprentice-table-header {
        .apprentice-data-table-actions {
            margin-top: map-get($grid-gutter-spacing, 'ten');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .roadmap-options {
        .input-group {
            flex-direction: row;
        }

        .btn-roadmap-management {
            width: auto;
        }

        .apprentice-primary-select {
            width: 1%;
            margin-bottom: 0;
            border-top-right-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
        }
    }

    .actions .btn:not(:last-child) {
        margin-bottom: 0;
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    ::v-deep .roadmap-options-table {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-table-filters,
            .apprentice-data-table-actions {
                flex: 0 0 auto;
            }

            .apprentice-data-table-actions {
                margin-top: 0;
            }
        }
    }
}
</style>
